import '@babel/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';

import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import green from '@material-ui/core/colors/green';
import 'typeface-roboto';

import './index.css';
import * as serviceWorker from './serviceWorker';
import SignatureTest from './components/SignatureTest';

const DBSIGN_BLUE = '#113D7F';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: DBSIGN_BLUE //indigo[700]
    },
    secondary: {
      main: green[700]
    }
  }
});

const styles = () => ({
  root: {
    //width: '100%'
  }
});

// eslint-disable-next-line
function AppWrapper({ classes }) {
  return (
    //$FlowFixMe
    <React.StrictMode>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <SignatureTest />
      </MuiThemeProvider>
    </React.StrictMode>
  );
}

const StyledAppWrapper = withStyles(styles)(AppWrapper);

const root: ?Element = document.getElementById('root');

if (root != null) {
  ReactDOM.render(<StyledAppWrapper />, root);

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  //serviceWorker.unregister();
  serviceWorker.register();
}
